var _defs, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBtnCarga(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #fff;\n      }\n\n      .st1 {\n        fill: #90acc0;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M69.3,409.2c-8.8,0-16-7.2-16-16v-253c0-8.8,7.2-16,16-16s16,7.2,16,16v253c0,8.8-7.2,16-16,16Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M197.3,362.7c-8.8,0-16-7.2-16-16v-160c0-8.8,7.2-16,16-16s16,7.2,16,16v160c0,8.8-7.2,16-16,16Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M282.7,352c-8.8,0-16-7.2-16-16v-138.7c0-8.8,7.2-16,16-16s16,7.2,16,16v138.7c0,8.8-7.2,16-16,16Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M368,341.3c-8.8,0-16-7.2-16-16v-117.3c0-8.8,7.2-16,16-16s16,7.2,16,16v117.3c0,8.8-7.2,16-16,16Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M442.7,336c-8.8,0-16-7.2-16-16v-101.3c0-8.8,7.2-16,16-16s16,7.2,16,16v101.3c0,8.8-7.2,16-16,16Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M497.4,138.7l-361.6-31.9c-1.4-.2-2.7-.2-4.2,0-.2,0-.4,0-.6,0-.2,0-.4,0-.6.1-.4,0-.9.2-1.3.3,0,0,0,0,0,0L11.8,139.2c-7,1.9-11.8,8.2-11.8,15.4v224c0,7.2,4.8,13.5,11.8,15.4l117.3,32c.4,0,.7.2,1.1.2.2,0,.4,0,.6,0,.2,0,.5,0,.7,0,.2,0,.4,0,.6,0,.4,0,.8,0,1.3,0s.8,0,1.2,0c0,0,.1,0,.2,0,0,0,0,0,0,0l362.7-32c8.3-.7,14.6-7.6,14.6-15.9v-224c0-8.3-6.3-15.2-14.6-15.9ZM32,166.9l85.3-23.3v246.1l-85.3-23.3v-199.6ZM480,364l-330.7,29.2v-253l330.7,29.2v194.7Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnCarga);
export default __webpack_public_path__ + "static/media/btn-carga.9ddc10b6677e40b231b5400ecfef511e.svg";
export { ForwardRef as ReactComponent };